import React, { useState } from 'react';
import { FaChartLine, FaIntercom, FaRadiationAlt, FaSpinner } from 'react-icons/fa';
import CopyToClipboard from '../../../core/components/CopyToClipboard';
import { urlWebsite } from '../../../../../config';
import { useSocket } from '../../../../../hooks/Socket';
import api from '../../../../../services/api';
import { useModal } from '../../../../../hooks/Modal';
import { useLoading } from '../../../../../hooks/LoadingHook';

interface ICreateModule {
  lineData: Record<string, any>;
}

export default function SocketLinkModule({
  lineData,
}: ICreateModule): JSX.Element {

  const { addModal } = useModal();
  const { addLoading, removeLoading } = useLoading();
  const check = async () => {

    addLoading({ title: 'Carregando', key: 'loading' });
    const posters = await api.get('/posters', { params: { where: { project_id: lineData?.url }, limitItems: 10000 } });
    const votes = await api.get('/favorite-posters', { params: { where: { project_id: lineData?.url }, limitItems: 10000 } });

    const eixosList: Array<Record<string, any>> = [];

    posters?.data?.rows.map(poster => {

      const indexEixo = eixosList?.findIndex(i => i?.title === poster?.eixo);
      const votesForPoster = votes?.data?.rows?.filter(vote => vote?.poster_id === poster?._id?.toString())?.length;

      if (poster?.status === 'yes') {
        if (indexEixo >= 0) {
          eixosList[indexEixo]?.posters.push({ ...poster, votes: votesForPoster || '0' });
        }
        else {
          eixosList.push({
            title: poster?.eixo,
            posters: [{ ...poster, votes: votesForPoster || '0' }]
          })
        }
      }


    })


    eixosList.map(eixo => {


      eixo.posters?.sort((a, b) => a.votes > b.votes ? -1 : a.votes < b.votes ? 1 : 0);


    })

    eixosList.sort((a, b) => a.title < b.title ? -1 : a.title > b.title ? 1 : 0);

    removeLoading('loading');
    addModal({
      title: 'Mais Votados', content: <>
        {eixosList?.map(eixo => {
          return <>

            <table className='table' style={{ margin: '0px auto', marginTop: '15px', maxWidth: '1200px', }}>
              <tbody>
                <tr><td colSpan={3} style={{ background: '#333' }}><h5 style={{ color: '#fff', fontSize: '18px' }}>{eixo.title}</h5></td></tr>

                <tr><td ><h2 style={{ color: '#333', fontWeight: 'bold' }}>Trabalho</h2></td>
                  <td ><h2 style={{ color: '#333', fontWeight: 'bold' }}>Autor</h2></td>
                  <td style={{ width: '60px', minWidth: '60px' }}><h2 style={{ color: '#333', fontWeight: 'bold' }}>Votos</h2></td>
                </tr>

                {eixo?.posters?.map(poster => {

                  return <tr key={`chat-${poster?._id?.toString()}`}><td>{poster?.title}</td><td>{poster?.author}</td><td>{poster?.votes || '0'}</td></tr>

                })}


              </tbody>
            </table>
          </>

        })}

      </>, theme: 'whiteModal'
    })


  }

  const moduleCreate = (): JSX.Element => {

    return <button type='button' className='lineIcon' onClick={() => check()} > <FaChartLine /> </button>
  }



  return moduleCreate();
}
